













import { defineComponent } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import SearchUserItem from "./SearchUserItem.vue";
import { FollowerMappedType } from "../type";

export default defineComponent({
  name: "SearchUserList",
  components: { SearchUserItem },
  props: {
    users: { type: Array as () => UserPublicData[], default: [] },
    mappedFollowings: { type: Object as () => FollowerMappedType, default: {} },
    loading: { type: Boolean },
    followingInProcessUsers: { type: Array as () => string[], default: [] },
  },
  methods: {
    follow(user: UserPublicData) {
      this.$emit("follow", user);
    },
  },
});
